import React from 'react'
import ReactEcharts from "echarts-for-react";
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';


const QuestionWiseAnalysis = ({ language_code, survey_id }) => {

    //States
    const { questionWiseAnalysis } = useSelector((state) => state.analyticsData)
    const { t, i18n } = useTranslation();

    //Options(Memo)
    const questionSurveys = useMemo(() => {
        const options = 'abcdefghijklmnopqrstuvwxyz'.split('')
        const colors = ['#E60000', '#FECB00', '#00B0CA', '#A8B400', '#9C2AA0', ' #EB9700', '#5E2750']
        
        let data = []
        let maxOptCount = 0
        let optData = {}
        questionWiseAnalysis?.forEach((que, index) => {
            data.push(`Q${index + 1}`)

            if (que.optionsInfo) {
                let tmpOpt = JSON.parse(que.optionsInfo)
                let opt = tmpOpt?.optionsText && tmpOpt?.optionsText[language_code]
                if (opt && typeof opt === 'object') {
                    let len = Object.keys(opt)?.length
                    if (len > maxOptCount) {
                        maxOptCount = len
                    }
                }
            }

        })

        for (let i = 0; i <= maxOptCount; i++) {
            optData[i] = []
        }

        questionWiseAnalysis?.forEach((que) => {
            if (que.optionsData) {
                let opt = que.optionsData
                if (opt && typeof opt === 'object') {
                    for (let i = 0; i <= maxOptCount; i++) {
                        if (i === maxOptCount) {
                            let percentage = ((que.notSelected ?? 0) / que.total) * 100
                            percentage = Number(percentage.toFixed(1))
                            optData[i].push(percentage)
                        }
                        else {
                            if (opt[i]) {
                                let percentage = (opt[i] / que.total) * 100
                                percentage = Number(percentage.toFixed(1))
                                optData[i].push(percentage)
                            } else {
                                optData[i].push(0)
                            }
                        }
                    }
                } else {
                    optData[0].push(opt)
                }

            } else {
                for (let i = 0; i <= maxOptCount; i++) {
                    optData[i].push(0)
                }
            }
        })

        let series = Object.keys(optData)?.map((optArr, index, arr) => {
            let colorKey = index % colors.length
            if (arr.length === index + 1) {
                return {
                    name:  t('analytics.notAns'),
                    barWidth: '20px',
                    type: 'bar',
                    stack: 'Survey',
                    emphasis: {
                        focus: 'series'
                    },
                    data: optData[optArr]?.length > 0 ? optData[optArr] : null,
                    itemStyle: {
                        color: 'rgb(151 151 151)'
                    },
                }
            }

            return {
                name: `Option ${options[index]}`,
                barWidth: '20px',
                type: 'bar',
                stack: 'Survey',
                emphasis: {
                    focus: 'series'
                },
                data: optData[optArr],
                itemStyle: {
                    color: colors[colorKey]
                }
            }
        })

        series = series.length > 0 ? series : []

        return {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                },
                valueFormatter: (value) => value + '%'
            },
            legend: {},
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                data: data,
                axisTick: {
                    alignWithLabel: true
                },
                axisLabel: {
                    interval: 0,
                    rotate: 40
                },
                splitLine: {
                    show: false
                }
            },
            yAxis: {
                type: 'value',
                name:  t('analytics.surveyCount'),
                nameLocation: 'middle',
                nameGap: 30,
            },
            series: series
        }

    }, [i18n.language,language_code, questionWiseAnalysis])

    return (
        <>
            <div className="card dashboard-card min-100">
                <div className="dashboard-card-header">
                    <h3>{t('analytics.question_wise')}
                    </h3>
                </div>
                <div className="card-body">
                    <div className="chart-wrapper">
                        <ReactEcharts
                            key={`${survey_id}_${Math.random()}`}
                            className='chart-height'
                            option={questionSurveys}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default QuestionWiseAnalysis